import { render } from "./PreviewAndSign.vue?vue&type=template&id=6bce0a9c"
import script from "./PreviewAndSign.vue?vue&type=script&lang=js"
export * from "./PreviewAndSign.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__